import React, { memo, Fragment, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Headerpro from "../../../../../components/partials/pro/headerstyle/header-pro";
import SponsoredSidebar from "../components/partials/sponsored-sidebar";
import Footer from "../../../../../components/partials/dashboard/footerstyle/footer";
import * as SettingSelector from "../../../../../store/setting/selectors";
import { useSelector } from "react-redux";
import "../../../../../assets/modules/e-commerce/scss/e-commerce.scss";
import useScrollToTop from "hooks/useScrollToTop";

const SponsoredLayout = memo(() => {
  const pageLayout = useSelector(SettingSelector.page_layout);
  const location = useLocation();

  useScrollToTop([location.pathname]);

  return (
    <Fragment>
      <SponsoredSidebar />
      <main className="main-content">
        <div className="position-relative">
          <Headerpro />
        </div>
        <div
          className={`container-fluid content-inner pb-0 ${pageLayout}`}
          id="page_layout"
        >
          <Suspense fallback={<div className="react-load"></div>}>
            <Outlet />
          </Suspense>
        </div>

        <Footer />
      </main>
    </Fragment>
  );
});

SponsoredLayout.displayName = "SponsoredLayout";
export default SponsoredLayout;
